<template>
  <div :class="classes" v-loading.fullscreen.lock="loading">
    <pt-form-item label="上传表格：" :required="true" labelWidth="100px">
      <!-- 上传组件 -->
      <el-upload
        ref="excel"
        class="upload-demo"
        action="aa"
        :auto-upload="false"
        :multiple="false"
        :on-change="changHandler"
        :on-remove="removeHandler"
        :file-list="excel"
        v-model="lotForm.excel" name="excel" v-validate="'required'" data-vv-as="上传文件">
        <el-button size="small" type="primary">点击上传</el-button>
        <br>
      </el-upload>
    </pt-form-item>

    <!-- <a :href="$privateResourcesUrlDownload+'templates/批量创建订单模板.xlsx'">
      <el-button type="text">下载文件模版</el-button>
    </a> -->
    <slot />
  </div>
</template>

<script>
import formMixins from 'mixins/form'
// 组件class前缀
const prefixCls = 'pt-holiday-excel-form'

export default {
  name: 'pt-holiday-excel-form',
  mixins: [formMixins],
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  data () {
    return {
      lotForm: {
        clientOrganizationId: '5b6e40155c0eb40001658280',
        remark: '',
        sender: '',
        courierNumber: [{ value: '' }],
        excel: []
      },
      excel: [],
      uploadForm: new FormData(),
      loading: false
    }
  },
  methods: {
    downLoadFile () {
      // this.$privateResourcesUrlDownload()rawdata/0001/sample_FinalReport_0001.txt
    },
    changHandler (file, fileList) {
      if (fileList.length > 1) {
        fileList.shift()
      }
      this.excel = fileList
      this.lotForm.excel = fileList
    },
    removeHandler (file, fileList) {
      this.excel = fileList
      this.lotForm.excel = fileList
    },
    submit () {
      this.loading = true
      this.uploadForm = new FormData()
      this.uploadForm.append('excel', this.excel[0].raw)
      let api
      switch (this.$route.meta.type) {
        case 'sign':
          api = 'importHolidayOfSign'
          break
        default:
          api = 'importHoliday'
          break
      }
      this.$store.dispatch(api, this.uploadForm).then(res => {
        // if (res.hasError) {
        //   this.loading = false
        //   this.lotForm.excel[0].status = 'ready'
        //   this.excel[0] = this.lotForm.excel[0]
        //   this.$emit('errorMsg', res.errors)
        // } else {
        this.excel[0].status = 'ready'
        this.loading = false
        this.$router.push('/holiday-manage')
        // }
      }).catch((error) => {
        this.loading = false
        this.lotForm.excel[0].status = 'ready'
        this.excel[0] = this.lotForm.excel[0]
        this.$message.error(error)
        // this.$emit('errorMsg')
      })
    }

  }
}
</script>

<style lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-holiday-excel-form{
  .el-input,el-date-editor{
    width:280px !important;
  }
  .el-upload-list{
    max-width: 800px;
  }
  el-textarea,.el-textarea__inner{
    width:500px;
  }
  .dashed{
    margin:30px 0;
    height: 1px;
    background-image: linear-gradient(to right, #ccc 0%, #ccc 50%, transparent 50%);
    background-size: 8px 1px;
    background-repeat: repeat-x;
  }
}
</style>
